import { useMemo } from 'react'
import { isEmpty, concat, sortBy } from 'lodash'
import {
  summarizeParticipantsDataByPlanNotificationServices,
  sumUpParticipantsSummaryDataNotificationServices,
  createParticipantsSummaryOverviewRowNotificationServices,
} from 'utils'

function useParticipantsSummaryNotificationServices(participants) {
  const [participantsSummaryData, participantsSummaryOverview] = useMemo(() => {
    if (isEmpty(participants)) return []

    const summaryDataByPlan =
      summarizeParticipantsDataByPlanNotificationServices(participants)
    const summaryOverview =
      sumUpParticipantsSummaryDataNotificationServices(summaryDataByPlan)
    const summaryOverviewRow =
      createParticipantsSummaryOverviewRowNotificationServices(summaryOverview)

    return [
      concat(sortBy(summaryDataByPlan, 'planName'), summaryOverviewRow),
      summaryOverview,
    ]
  }, [participants])

  return {
    data: participantsSummaryData,
    overview: participantsSummaryOverview,
  }
}

export default useParticipantsSummaryNotificationServices
